import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import React from 'react';
import styles from '@/styles/Corporate.module.css';
import { useRouter } from 'next/router';
import CorporatePage from '@/components/CorporatePage/CorporatePage';
import { getOrFetchCorporateContent } from '@/utils/corporateCalls';

import { getLayoutProps } from '@/utils/layout/layout';
import { CustomMetaHead } from '@/components/CustomMetaHead/CustomMetaHead';
import { getComponent, getCorporateContentPageBySlug } from '@/api/cms';
import DefaultProductImage from '../../../../public/assets/wave-grocery/Empty-States-Default/DefaultProductImage.png';

export default function CorporateContent({ layoutList, responsiveLogo, extractedArray, dataList, emptyStates }) {
  const router = useRouter();
  const { slug } = router.query;
  const index = extractedArray?.findIndex?.(obj => obj.content.slug === slug[0]);
  const title = extractedArray?.[index]?.content?.title;
  const metadata = extractedArray?.[index]?.content?.metadata;
  const subtitle = extractedArray?.[index]?.content?.subtitle ?? undefined;
  const defaultProdImg = emptyStates?.default_product_image?.url || DefaultProductImage.src;

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <CustomMetaHead metadata={metadata} />

      <main className={styles.mainContainer}>
        <div className={styles.corpContainer}>
          <CorporatePage
            layoutList={layoutList}
            dataList={dataList}
            title={title}
            subtitle={subtitle}
            defaultProductImage={defaultProdImg}
          />
        </div>
      </main>
    </>
  );
}

CorporateContent.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticPaths({ locales }) {
  // const [corporateContent] = await Promise.all([getOrFetchCorporateContent()]);

  // const paths = corporateContent.data.data.map(path => {
  //   return {
  //     params: { slug: [path.content.slug] },
  //   };
  // });

  // const localizedPaths = [];
  // for (const locale of locales) {
  //   for (const path of paths) localizedPaths.push({ ...path, locale });
  // }

  // return { paths: localizedPaths, fallback: false };

  // TODO: Add some important paths
  return { paths: [], fallback: 'blocking' };
}

export async function getStaticProps(context) {
  try {
    const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, context.locale);
    // const title = corporateContentData;
    const { data: pageData } = await getCorporateContentPageBySlug(context.params.slug[0], context.locale);

    const rootActiveComponents = pageData.data[0].content.content_component.filter(el => el.enabled);
    const subComponents = rootActiveComponents.map(comp => comp.conten_sub_schema);

    const subComponentsPopulated = (
      await Promise.all(subComponents.map(comp => getComponent(comp.id, context.locale)))
    ).map(el => el.data);

    const extractedArray = pageData.data;
    const layoutList = rootActiveComponents.map(el => el.conten_sub_schema.schema);
    const dataList = subComponentsPopulated.map(component => ({
      content: component.data[0].content,
      included: component.included,
    }));

    const messages = {
      common: (await import(`../../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
      product_details: (await import(`../../../../prebuild-data/i18n/${context.locale}/product_details.json`)).default,
      user_history: (await import(`../../../../prebuild-data/i18n/${context.locale}/user_history.json`)).default,
    };

    return {
      props: {
        ...layoutProps,
        layoutList,
        dataList,
        extractedArray,
        messages,
      },
      revalidate: 1800,
    };
  } catch (err) {
    console.log(err);
    return {
      notFound: true,
    };
  }
}
